var React = require('react');

function IconUnlock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.5 14H27a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V17a3 3 0 0 1 3-3h15.5V9.5C20.5 7.019 18.481 5 16 5a4.505 4.505 0 0 0-4.5 4.5h-5C6.5 4.263 10.762 0 16 0s9.5 4.263 9.5 9.5V14Z","fill":"#ffffff"}));
}

IconUnlock.defaultProps = {"fill":"currentColor","viewBox":"0 0 32 32"};

module.exports = IconUnlock;

IconUnlock.default = IconUnlock;
